import { render } from "./modalOrderSteps.vue?vue&type=template&id=b8c56c0c&scoped=true&lang=html"
import script from "./modalOrderSteps.vue?vue&type=script&lang=js"
export * from "./modalOrderSteps.vue?vue&type=script&lang=js"

import "./modalOrderSteps.vue?vue&type=style&index=0&id=b8c56c0c&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8c56c0c"]])

export default __exports__